const STORAGE_KEY = "pos.language";

export const SUPPORTED_LANGUAGES = ["en", "ar"];

export function getStoredLanguage() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (SUPPORTED_LANGUAGES.includes(stored)) return stored;
    } catch {
        // ignore
    }
    return "en";
}

export function setStoredLanguage(lang) {
    try {
        if (SUPPORTED_LANGUAGES.includes(lang)) {
            localStorage.setItem(STORAGE_KEY, lang);
        }
    } catch {
        // ignore
    }
}

